import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/(tournaments)/tournaments/components/tournaments_grid/archived_tournaments_grid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/(tournaments)/tournaments/components/tournaments_header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/(tournaments)/tournaments/components/tournaments_hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/(tournaments)/tournaments/components/tournaments_mobile_ctrl.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TournamentsSectionProvider"] */ "/app/front_end/src/app/(main)/(tournaments)/tournaments/components/tournaments_provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/app/(main)/(tournaments)/tournaments/components/tournaments_results.tsx");
